export default __webpack_public_path__ + "static/media/s_linkedIn_l.6c163e60.svg";